import axios, { AxiosRequestConfig } from 'axios'
import { ScanInfoResponse } from './api_data_types'
import { scan_info_api_job_number_path } from '../routes'

export function getScanInfo(jobnumberId: number): Promise<ScanInfoResponse> {
  const options: AxiosRequestConfig = {
    url: scan_info_api_job_number_path(jobnumberId, { format: 'json' }),
    method: 'get',
    responseType: 'json',
  }

  return axios(options).then(response => response.data)
}
